import React from 'react';

export function NotificationPreview({
  body,
}: {
  body: string;
}): React.ReactNode {
  return (
    <iframe
      title="email-preview"
      sandbox=""
      srcDoc={body}
      style={{ width: '100%', height: '100%', border: 0, background: 'white' }}
    />
  );
}
